module.exports = __webpack_public_path__ + "img/knollhurst-layer-0.b8738a09.png";